import { atom } from "recoil";

export const pageTitleState = atom<string>({
  key: "pageTitleState",
  default: "",
});
